/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';
import {
    JsonStratSuccessLook,
    JsonStratSuccessLookFromJSON,
    JsonStratSuccessLookFromJSONTyped,
    JsonStratSuccessLookToJSON,
} from './JsonStratSuccessLook';
import {
    JsonStratTeam,
    JsonStratTeamFromJSON,
    JsonStratTeamFromJSONTyped,
    JsonStratTeamToJSON,
} from './JsonStratTeam';

/**
 * 
 * @export
 * @interface JsonStratEnabler
 */
export interface JsonStratEnabler {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonStratEnabler
     */
    allowedActions?: Array<JsonStratEnablerAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonStratEnabler
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnabler
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnabler
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnabler
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnabler
     */
    enablerId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JsonStratEnabler
     */
    isRemoved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnabler
     */
    onepagerId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnabler
     */
    orderNo?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnabler
     */
    status?: JsonStratEnablerStatusEnum;
    /**
     * 
     * @type {Array<JsonStratSuccessLook>}
     * @memberof JsonStratEnabler
     */
    successLooks?: Array<JsonStratSuccessLook>;
    /**
     * 
     * @type {Array<JsonStratTeam>}
     * @memberof JsonStratEnabler
     */
    teams?: Array<JsonStratTeam>;
    /**
     * 
     * @type {string}
     * @memberof JsonStratEnabler
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratEnabler
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonStratEnablerAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonStratEnablerStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonStratEnablerFromJSON(json: any): JsonStratEnabler {
    return JsonStratEnablerFromJSONTyped(json, false);
}

export function JsonStratEnablerFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonStratEnabler {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enablerId': !exists(json, 'enablerId') ? undefined : json['enablerId'],
        'isRemoved': !exists(json, 'isRemoved') ? undefined : json['isRemoved'],
        'onepagerId': !exists(json, 'onepagerId') ? undefined : json['onepagerId'],
        'orderNo': !exists(json, 'orderNo') ? undefined : json['orderNo'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'successLooks': !exists(json, 'successLooks') ? undefined : ((json['successLooks'] as Array<any>).map(JsonStratSuccessLookFromJSON)),
        'teams': !exists(json, 'teams') ? undefined : ((json['teams'] as Array<any>).map(JsonStratTeamFromJSON)),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonStratEnablerToJSON(value?: JsonStratEnabler | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'description': value.description,
        'enablerId': value.enablerId,
        'isRemoved': value.isRemoved,
        'onepagerId': value.onepagerId,
        'orderNo': value.orderNo,
        'status': value.status,
        'successLooks': value.successLooks === undefined ? undefined : ((value.successLooks as Array<any>).map(JsonStratSuccessLookToJSON)),
        'teams': value.teams === undefined ? undefined : ((value.teams as Array<any>).map(JsonStratTeamToJSON)),
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

